import { Directive, ElementRef, HostListener, Output, EventEmitter } from "@angular/core";
import { NgControl } from "@angular/forms";
import { AppCommon } from "@app/shared/common/app/app-common";

@Directive({
    selector: '[codeInput]'
})

export class CodeInputDirective {
    @Output() ngModelChange: EventEmitter<string> = new EventEmitter();
  //  private regex: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);

    constructor(private el: ElementRef) {
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.el.nativeElement.value;
       
        this.el.nativeElement.value =  this.convertString(initalValue);
        
        if ( initalValue !== this.el.nativeElement.value) {
          event.stopPropagation();
        }

        this.ngModelChange.emit(this.el.nativeElement.value);
      }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {        
        this.validateFields(event);
    }

    validateFields(event) {
        setTimeout(() => {
            const initalValue = this.el.nativeElement.value;
       
            this.el.nativeElement.value =  this.convertString(initalValue);
            
            this.ngModelChange.emit(this.el.nativeElement.value);

            event.preventDefault();

        }, 100)
    }

    convertString(value) {
        return AppCommon.ConvertToUnSign(value).replace(/\s/g, "").replace(/[^\w\s]/gi, '').replace(/_/,'');
    }
}